import React from "react";
import Skeleton from "../ui/Skeleton";

export const ScheduleManagerSkeleton: React.FC = () => {
  return (
    <div className="w-full">
      {/* Filter Bar Skeleton - full-bleed sticky bar, mesmo padrão de "Postagens" */}
      <div className="-mt-4 -mx-2 pl-4 pr-2 xl:pl-5 xl:pr-3 py-1.5 bg-white/95 border-b border-purple-200 flex flex-col gap-3">
        <div className="w-full">
          <div className="flex flex-row flex-wrap gap-2 sm:gap-2.5 items-center">
            {/* Busca */}
            <div className="flex-1 min-w-[200px] sm:min-w-[250px]">
              <Skeleton
                variant="rectangular"
                width="100%"
                height={32}
                className="rounded-lg"
              />
            </div>

            {/* Filtros de Visualização (Pills) */}
            <div className="hidden lg:flex items-center gap-2 shrink-0 mx-2">
              <Skeleton
                variant="rectangular"
                width={110}
                height={32}
                className="rounded-full"
              />
              <Skeleton
                variant="rectangular"
                width={110}
                height={32}
                className="rounded-full"
              />
            </div>

            {/* Filtro de Status */}
            <div className="hidden lg:block w-[150px] shrink-0 ml-auto">
              <Skeleton
                variant="rectangular"
                width="100%"
                height={32}
                className="rounded-lg"
              />
            </div>

            {/* Alternar Lista/Mensal */}
            <div className="shrink-0">
              <Skeleton
                variant="rectangular"
                width={68}
                height={32}
                className="rounded-xl"
              />
            </div>
          </div>

          {/* Mobile Pills */}
          <div className="lg:hidden flex flex-wrap gap-2 mt-3 pt-3 border-t border-purple-200">
            <Skeleton
              variant="rectangular"
              width={90}
              height={28}
              className="rounded-full"
            />
            <Skeleton
              variant="rectangular"
              width={90}
              height={28}
              className="rounded-full"
            />
            <Skeleton
              variant="rectangular"
              width={70}
              height={28}
              className="rounded-full"
            />
          </div>
        </div>
      </div>

      {/* Conteúdo: seções por data (estilo lista) */}
      <div className="mt-2 space-y-3">
        {[1, 2].map((dateIndex) => (
          <div
            key={dateIndex}
            className="border border-purple-200 rounded-xl p-3 sm:p-4 bg-linear-to-br from-white to-purple-50/30"
          >
            {/* Header da Data */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-3 pb-2 border-b border-purple-200">
              <div className="flex items-center gap-3">
                <Skeleton
                  variant="rectangular"
                  width={44}
                  height={44}
                  className="rounded-xl"
                />
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <Skeleton
                      variant="text"
                      width={160}
                      height={20}
                      className="sm:w-48"
                    />
                    <Skeleton
                      variant="rectangular"
                      width={50}
                      height={18}
                      className="rounded-full"
                    />
                  </div>
                  <div className="flex items-center gap-2">
                    <Skeleton
                      variant="rectangular"
                      width={65}
                      height={18}
                      className="rounded-md"
                    />
                    <Skeleton
                      variant="text"
                      width={100}
                      height={14}
                      className="sm:w-32"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="bg-white border border-purple-200 rounded-xl p-4 flex flex-col h-full shadow-xs"
                >
                  <div className="flex items-start justify-between gap-2 mb-3">
                    <div className="flex flex-wrap items-center gap-2 flex-1 min-w-0">
                      <Skeleton
                        variant="rectangular"
                        width={60}
                        height={20}
                        className="rounded-full"
                      />
                      <Skeleton
                        variant="rectangular"
                        width={70}
                        height={20}
                        className="rounded-full"
                      />
                    </div>
                    <Skeleton
                      variant="rectangular"
                      width={28}
                      height={28}
                      className="rounded-lg"
                    />
                  </div>

                  <div className="flex-1 space-y-3 mb-4">
                    <div className="bg-gray-50/50 p-2.5 rounded-lg border border-purple-200">
                      <Skeleton
                        variant="text"
                        width="100%"
                        height={12}
                        className="mb-1"
                      />
                      <Skeleton variant="text" width="80%" height={12} />
                    </div>
                  </div>

                  <div className="space-y-3 mt-auto pt-3 border-t border-purple-200">
                    <div className="flex items-center justify-between">
                      <Skeleton variant="text" width={80} height={10} />
                      <Skeleton variant="text" width={40} height={10} />
                    </div>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={32}
                      className="rounded-lg"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduleManagerSkeleton;
